import React from 'react';
import useApiDynamicSwitchState, {ApiDynamicSwitchProps} from './state';
import {Container} from './styles';
import Loading from '../loading';
import {Switch} from '@mantine/core';

const ApiDynamicSwitch: React.FC<ApiDynamicSwitchProps> = (props) => {
  const {isLoading, handleRequest} = useApiDynamicSwitchState(props);

  return isLoading ? (
    <Container>
      <Loading />
    </Container>
  ) : (
    <Switch
      onChange={(e) => handleRequest(e.currentTarget.checked)}
      checked={props.isChecked}></Switch>
  );
};

export default ApiDynamicSwitch;
